export default Object.freeze({
  /**
   * aka Forms2
   */
  internal: 'internal',
  jotForm: 'jotForm',
})
